<script setup lang="ts">
import type { IPromoProduct } from "@magnit/unit-catalog/src/unit-catalog.types";
import type { IBreadcrumbsItemProps } from "~/components/VBreadcrumbs/VBreadcrumbs.types";

const props = defineProps<{
  promoProduct: IPromoProduct;
}>();

const promoProduct = computed(() => props.promoProduct);
const { productCategoriesTree } = useProduct(promoProduct);

const breadcrumbs = computed(() => {
  const result: IBreadcrumbsItemProps[] = [
    {
      to: Routes.Main,
      title: "Главная",
    },
  ];
  return productCategoriesTree.value
    ? [...result, ...productCategoriesTree.value]
    : result;
});
</script>

<template>
  <div class="popular-detail-top-nav">
    <VBreadcrumbsWrapped
      :items="breadcrumbs"
      class="popular-detail-top-nav__breadcrumbs"
    />
    <VWrapperLocal>
      <VPageBack
        :route="Routes.Main"
        text="Главная"
        class="popular-detail-top-nav__backlink"
      />
    </VWrapperLocal>
  </div>
</template>
